import { LockClosedIcon } from '@heroicons/react/24/outline'
import { Link } from 'libs/router'

import { useTranslation } from 'libs/i18n'

type SecurityCardProps = {
	passwordReset?: boolean
	passwordChange?: boolean
	passwordChangeLink: string
}

const linkClassName =
	'inline-flex h-9 w-full items-center justify-center rounded-md bg-primary-soft px-4 text-sm font-medium text-foreground shadow-sm transition-colors hover:bg-primary-soft/80'

export const SecurityCard = ({
	passwordChange = true,
	passwordReset = true,
	passwordChangeLink
}: SecurityCardProps) => {
	const { t } = useTranslation()

	return (
		<aside className="rounded-lg border border-border bg-card p-5 shadow-panel sm:p-6 lg:sticky lg:top-6">
			<div className="grid h-10 w-10 place-items-center rounded-md bg-muted text-muted-foreground">
				<LockClosedIcon className="h-5 w-5" />
			</div>
			<h2 className="mt-4 font-display text-lg font-semibold text-foreground">{t('Security')}</h2>
			<p className="mt-2 text-sm leading-6 text-muted-foreground">
				{t('Keep your account safe by updating your password regularly.')}
			</p>
			<div className="mt-5 grid gap-2">
				{passwordReset ? (
					<Link className={linkClassName} to="/password-reset">
						{t('Reset password')}
					</Link>
				) : null}
				{passwordChange ? (
					<Link className={linkClassName} to={passwordChangeLink}>
						{t('Change password')}
					</Link>
				) : null}
			</div>
		</aside>
	)
}
